export default __webpack_public_path__ + "static/media/aussiep19-400x482.de3c8d58.jpg";